// extracted by mini-css-extract-plugin
module.exports = {"itemsList":"styles_itemsList__3Z_b8","isDraggingOver":"styles_isDraggingOver__3a6N-"};